import { render, staticRenderFns } from "./MarchandOffreView.vue?vue&type=template&id=354d66b4&scoped=true&"
import script from "./MarchandOffreView.vue?vue&type=script&lang=js&"
export * from "./MarchandOffreView.vue?vue&type=script&lang=js&"
import style0 from "./MarchandOffreView.vue?vue&type=style&index=0&id=354d66b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354d66b4",
  null
  
)

export default component.exports